import React from 'react';
import { usePopper } from '../../../utils/usePopper';
export var DropdownList = React.forwardRef(function (_a, ref) {
    var onFocus = _a.onFocus, options = _a.options, onSelectOption = _a.onSelectOption, getOptionLabel = _a.getOptionLabel, referenceElement = _a.referenceElement;
    var mountingPoint = React.useMemo(function () { return document.createElement('div'); }, []);
    React.useLayoutEffect(function () {
        if ((ref === null || ref === void 0 ? void 0 : ref.current) != null) {
            var referenceRect = referenceElement.current.getBoundingClientRect();
            ref.current.style.minWidth = referenceRect.width + "px";
        }
    });
    var _b = usePopper(referenceElement, ref), popperStyle = _b.style, scheduleUpdate = _b.scheduleUpdate, placement = _b.placement;
    React.useLayoutEffect(function () {
        document.body.appendChild(mountingPoint);
        return function () {
            document.body.removeChild(mountingPoint);
        };
    }, [mountingPoint]);
    // Make sure the item list (popover) is always correctly positioned.
    React.useLayoutEffect(function () {
        scheduleUpdate();
    });
    return (React.createElement("ul", { tabIndex: -1, onFocus: onFocus, ref: ref, style: popperStyle, "data-placement": placement, className: "cursor-pointer p-4 border-2 border-neutral-3 rounded border-g bg-neutral-2 flex flex-col" }, options.map(function (option, index) { return (React.createElement("li", { key: index, onClick: function () { return onSelectOption(option); }, className: "pl-4 h-12 text-neutral-8 rounded flex justify-start items-center hover:bg-neutral-3" },
        React.createElement("span", { className: "select-none" }, getOptionLabel(option)))); })));
});
